/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CreateFireAlarmCallPointCommandControllerCreate201,
  CreateFireAlarmCallPointDto,
  FireAlarmCallPointResponseDto,
  ListFireAlarmCallPointsQueryControllerListParams,
  UpdateFireAlarmCallPointCommandControllerUpdate200,
  UpdateFireAlarmCallPointDto,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * @summary Register a fire alarm call point for a nursery
 */
export const createFireAlarmCallPointCommandControllerCreate = (
  nurseryId: string,
  createFireAlarmCallPointDto: CreateFireAlarmCallPointDto,
  signal?: AbortSignal,
) => {
  return axiosClient<CreateFireAlarmCallPointCommandControllerCreate201>({
    url: `/v1/nurseries/${nurseryId}/fire-alarm-call-points`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createFireAlarmCallPointDto,
    signal,
  });
};

export const getCreateFireAlarmCallPointCommandControllerCreateMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createFireAlarmCallPointCommandControllerCreate>
      >,
      TError,
      { nurseryId: string; data: CreateFireAlarmCallPointDto },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof createFireAlarmCallPointCommandControllerCreate>>,
    TError,
    { nurseryId: string; data: CreateFireAlarmCallPointDto },
    TContext
  > => {
    const mutationKey = ["createFireAlarmCallPointCommandControllerCreate"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createFireAlarmCallPointCommandControllerCreate>
      >,
      { nurseryId: string; data: CreateFireAlarmCallPointDto }
    > = (props) => {
      const { nurseryId, data } = props ?? {};

      return createFireAlarmCallPointCommandControllerCreate(nurseryId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateFireAlarmCallPointCommandControllerCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createFireAlarmCallPointCommandControllerCreate>>
  >;
export type CreateFireAlarmCallPointCommandControllerCreateMutationBody =
  CreateFireAlarmCallPointDto;
export type CreateFireAlarmCallPointCommandControllerCreateMutationError = void;

/**
 * @summary Register a fire alarm call point for a nursery
 */
export const useCreateFireAlarmCallPointCommandControllerCreate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createFireAlarmCallPointCommandControllerCreate>
      >,
      TError,
      { nurseryId: string; data: CreateFireAlarmCallPointDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createFireAlarmCallPointCommandControllerCreate>>,
  TError,
  { nurseryId: string; data: CreateFireAlarmCallPointDto },
  TContext
> => {
  return useMutation(
    getCreateFireAlarmCallPointCommandControllerCreateMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary List all fire alarm call points for a nursery
 */
export const listFireAlarmCallPointsQueryControllerList = (
  nurseryId: string,
  params?: ListFireAlarmCallPointsQueryControllerListParams,
  signal?: AbortSignal,
) => {
  return axiosClient<FireAlarmCallPointResponseDto[]>({
    url: `/v1/nurseries/${nurseryId}/fire-alarm-call-points`,
    method: "GET",
    params,
    signal,
  });
};

export const getListFireAlarmCallPointsQueryControllerListQueryKey = (
  nurseryId: string,
  params?: ListFireAlarmCallPointsQueryControllerListParams,
) => {
  return [
    `/v1/nurseries/${nurseryId}/fire-alarm-call-points`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListFireAlarmCallPointsQueryControllerListQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listFireAlarmCallPointsQueryControllerList>
  >,
  TError = void,
>(
  nurseryId: string,
  params?: ListFireAlarmCallPointsQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listFireAlarmCallPointsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListFireAlarmCallPointsQueryControllerListQueryKey(nurseryId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listFireAlarmCallPointsQueryControllerList>>
  > = ({ signal }) =>
    listFireAlarmCallPointsQueryControllerList(nurseryId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listFireAlarmCallPointsQueryControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListFireAlarmCallPointsQueryControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof listFireAlarmCallPointsQueryControllerList>>
>;
export type ListFireAlarmCallPointsQueryControllerListQueryError = void;

export function useListFireAlarmCallPointsQueryControllerList<
  TData = Awaited<
    ReturnType<typeof listFireAlarmCallPointsQueryControllerList>
  >,
  TError = void,
>(
  nurseryId: string,
  params: undefined | ListFireAlarmCallPointsQueryControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listFireAlarmCallPointsQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listFireAlarmCallPointsQueryControllerList>
          >,
          TError,
          Awaited<ReturnType<typeof listFireAlarmCallPointsQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListFireAlarmCallPointsQueryControllerList<
  TData = Awaited<
    ReturnType<typeof listFireAlarmCallPointsQueryControllerList>
  >,
  TError = void,
>(
  nurseryId: string,
  params?: ListFireAlarmCallPointsQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listFireAlarmCallPointsQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listFireAlarmCallPointsQueryControllerList>
          >,
          TError,
          Awaited<ReturnType<typeof listFireAlarmCallPointsQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListFireAlarmCallPointsQueryControllerList<
  TData = Awaited<
    ReturnType<typeof listFireAlarmCallPointsQueryControllerList>
  >,
  TError = void,
>(
  nurseryId: string,
  params?: ListFireAlarmCallPointsQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listFireAlarmCallPointsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List all fire alarm call points for a nursery
 */

export function useListFireAlarmCallPointsQueryControllerList<
  TData = Awaited<
    ReturnType<typeof listFireAlarmCallPointsQueryControllerList>
  >,
  TError = void,
>(
  nurseryId: string,
  params?: ListFireAlarmCallPointsQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listFireAlarmCallPointsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListFireAlarmCallPointsQueryControllerListQueryOptions(
      nurseryId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a fire alarm call point
 */
export const updateFireAlarmCallPointCommandControllerUpdate = (
  nurseryId: string,
  fireAlarmCallPointId: string,
  updateFireAlarmCallPointDto: UpdateFireAlarmCallPointDto,
  signal?: AbortSignal,
) => {
  return axiosClient<UpdateFireAlarmCallPointCommandControllerUpdate200>({
    url: `/v1/nurseries/${nurseryId}/fire-alarm-call-points/${fireAlarmCallPointId}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateFireAlarmCallPointDto,
    signal,
  });
};

export const getUpdateFireAlarmCallPointCommandControllerUpdateMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateFireAlarmCallPointCommandControllerUpdate>
      >,
      TError,
      {
        nurseryId: string;
        fireAlarmCallPointId: string;
        data: UpdateFireAlarmCallPointDto;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof updateFireAlarmCallPointCommandControllerUpdate>>,
    TError,
    {
      nurseryId: string;
      fireAlarmCallPointId: string;
      data: UpdateFireAlarmCallPointDto;
    },
    TContext
  > => {
    const mutationKey = ["updateFireAlarmCallPointCommandControllerUpdate"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateFireAlarmCallPointCommandControllerUpdate>
      >,
      {
        nurseryId: string;
        fireAlarmCallPointId: string;
        data: UpdateFireAlarmCallPointDto;
      }
    > = (props) => {
      const { nurseryId, fireAlarmCallPointId, data } = props ?? {};

      return updateFireAlarmCallPointCommandControllerUpdate(
        nurseryId,
        fireAlarmCallPointId,
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateFireAlarmCallPointCommandControllerUpdateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateFireAlarmCallPointCommandControllerUpdate>>
  >;
export type UpdateFireAlarmCallPointCommandControllerUpdateMutationBody =
  UpdateFireAlarmCallPointDto;
export type UpdateFireAlarmCallPointCommandControllerUpdateMutationError = void;

/**
 * @summary Update a fire alarm call point
 */
export const useUpdateFireAlarmCallPointCommandControllerUpdate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateFireAlarmCallPointCommandControllerUpdate>
      >,
      TError,
      {
        nurseryId: string;
        fireAlarmCallPointId: string;
        data: UpdateFireAlarmCallPointDto;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateFireAlarmCallPointCommandControllerUpdate>>,
  TError,
  {
    nurseryId: string;
    fireAlarmCallPointId: string;
    data: UpdateFireAlarmCallPointDto;
  },
  TContext
> => {
  return useMutation(
    getUpdateFireAlarmCallPointCommandControllerUpdateMutationOptions(options),
    queryClient,
  );
};
